import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isApiSync: boolean;
}

// 페이지 타이틀 + 티어별 안내 문구 — API 연동 미허용은 엑셀 다운로드, 허용은 API 연동 관점의 문구를 쓴다.
function PathPickSyncDownloadHistoryHeader({ isApiSync }: Props) {
  const { t } = useI18nHelper();

  return (
    <Flex flexDirection={"column"} gap={"2px"}>
      <Text textStyle={"body-lg-bold"}>
        {t("path_pick:sync_download_history.title")}
      </Text>
      <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
        {t(
          isApiSync
            ? "path_pick:sync_download_history.description_pro"
            : "path_pick:sync_download_history.description_basic"
        )}
      </Text>
    </Flex>
  );
}

export default PathPickSyncDownloadHistoryHeader;
